import { createGlobalStyle } from "styled-components";
import { GlobalClasses } from "./GlobalClasses";

export const GlobalStyle = createGlobalStyle`
    ${GlobalClasses}
`;
